/* eslint-disable max-len */
import { PrimaryButton, TertiaryButton } from '@components/library/button';
import { StandardDialog } from '@components/library/dialog';
import React, { Dispatch, FunctionComponent, SetStateAction } from 'react';

export interface ConnectDeniedDialogProps {
  isCtaDialogOpen: boolean;
  setIsCtaDialogOpen: Dispatch<SetStateAction<boolean>>;
  handleSmartsheetConnectClick: () => void;
}

export const ConnectDeniedDialog: FunctionComponent<ConnectDeniedDialogProps> = ({ isCtaDialogOpen, setIsCtaDialogOpen, handleSmartsheetConnectClick }) => {
  return (
    <StandardDialog
      dialogBodyClassName="smartsheet-cta-dialog-body"
      dialogHeaderClassName="smartsheet-cta-dialog-header"
      footer={
        <div className="smartsheet-cta-dialog__buttons">
          <TertiaryButton
            className="smartsheet-cta-dialog__explore"
            onClick={(): void => {
              window.open(
                'https://brandfolder.com/product/smartsheet-and-brandfolder/',
                '_blank'
              );
              setIsCtaDialogOpen(false);
            }}
          >
            {bfTranslate('Explore Smartsheet')}
          </TertiaryButton>
          <PrimaryButton
            className="smartsheet-cta-dialog__connect"
            loadingCopy={bfTranslate('Connecting')}
            onClick={(): void => {
              handleSmartsheetConnectClick();
              setIsCtaDialogOpen(false);
            }}
          >
            {bfTranslate('Connect Smartsheet')}
          </PrimaryButton>
        </div>
      }
      height={721}
      id="smartsheet-cta-dialog"
      onClose={(): void => setIsCtaDialogOpen(false)}
      open={isCtaDialogOpen}
      setOpen={setIsCtaDialogOpen}
      title={bfTranslate('You chose not to connect to Smartsheet')}
      width={721}
    >
      <div className="smartsheet-cta-dialog__body">
        <p>
          {bfTranslate(
            'Get the most out of Brandfolder Workspaces by connecting Smartsheet and bringing marketing, creative, and content together in one place.'
          )}
        </p>
      </div>
    </StandardDialog>
  );
};